export const defaultFlowFlags = () => ({
  allowPeriodicSubscriptions: false,
  allowSendAccountWithoutOperations: false,
  allowPensionPlans: false,
  allowFiscalItems: false,
  allowAML: false,
  allowExternalCodesFromSM: false,
  allowMarketerChange: false,
  nrbeRequired: false,
  allowEditSubdistributor: false,
  allowAutoClassSelection: false,

  s3Path: null,
  defaultDistributorUuid: null
});

export default {
    configVars: {},
    flowFlags: defaultFlowFlags()
};
